import React, { lazy, Suspense, useState, useEffect } from 'react'
// import { BrowserRouter as Router, Route, Switch, withRouter } from 'react-router-dom'
import { HashRouter as Router, Route, Switch, withRouter } from 'react-router-dom'
import { CssBaseline } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { dsv } from 'd3-fetch'
import csvFileName from 'data/worklist.csv'

import { Drawer, AppBar, Loading } from 'components'
import { useToggle } from 'utils'
import Favoritos from './trabalhos/favoritos';
import Trabalhos from './trabalhos';
import BookMarksPage from './bookmarks';
// import Notifier, { openSnackbar } from 'components/Notifier';
import PureNotifier from 'components/PureNotifier';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100vh',
    position: 'relative',
    display: 'flex',
  },
  content: {
    flexGrow: 1,
    overflowY: 'auto',
    // backgroundColor: (theme.palette.type === 'dark') ? '#191919' : '#fafafa',
    backgroundColor: (theme.palette.type === 'dark') ? '#191919' : '#ffffff',
    padding: theme.spacing.unit * 3,
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    height: 48,
  },
}))

const routes = [
  {
    path: '/',
    render: withRouter(lazy(() => import('./inicial')))
  },
  {
    path: '/rate-papers',
    render: withRouter(lazy(() => import('./avaliar-trabalho')))
  },
  {
    path: '/agenda',
    render: withRouter(lazy(() => import('./programacao')))
  },
  {
    path: '/poster-map',
    render: withRouter(lazy(() => import('./poster-map')))
  },
  {
    path: '/info',
    render: withRouter(lazy(() => import('./infos')))
  },
  {
    path: '/workshops',
    render: withRouter(lazy(() => import('./workshops')))
  },
  {
    path: '(.*)',
    render: withRouter(lazy(() => import('./error')))
  },
]

let favoritesInitializedFromLocalStorage = false
let bookmarksInitializedFromLocalStorage = false

const useStateWithLocalStorage = (localStorageKey, flag) => {
  const [value, setValue] = React.useState(() => {
    flag = true
    return JSON.parse(localStorage.getItem(localStorageKey)) || []
  }
  );

  return [value, setValue];
};

function App() {
  const classes = useStyles()
  const _useToggle = useToggle()
  const [works, setWorks] = useState(null)
  const [triggerNotifier, setTriggerNotifier] = useState({show: false, message: 'Initial Message', variant: ''})
  const [favorites, setFavorites] = useStateWithLocalStorage(
    'favoritesWorksPse2019', favoritesInitializedFromLocalStorage
  );
  const [bookmarks, setBookmarks] = useStateWithLocalStorage(
    'bookMarksWorksPse2019', bookmarksInitializedFromLocalStorage
  );

  useEffect(() => {
    // console.log('effect fav!')
    localStorage.setItem('favoritesWorksPse2019', JSON.stringify(favorites));
    localStorage.setItem('bookMarksWorksPse2019', JSON.stringify(bookmarks));
  });

  if (favoritesInitializedFromLocalStorage && works) {
    if (favorites.length > 0) {
      setWorks((works) => {
        let worksNew = [...works]
        for (let i = 0; i < favorites.length; i++) {
          const idxFavorited = works.findIndex(item => item.ID === favorites[i].ID)
          worksNew[idxFavorited] = { ...worksNew[idxFavorited], favorited: true }
        }
        return worksNew
      })
    }
    favoritesInitializedFromLocalStorage = false
  }

  if (bookmarksInitializedFromLocalStorage && works) {
    if (bookmarks.length > 0) {
      setWorks((works) => {
        let worksNew = [...works]
        for (let i = 0; i < bookmarks.length; i++) {
          const idxFavorited = works.findIndex(item => item.ID === bookmarks[i].ID)
          worksNew[idxFavorited] = { ...worksNew[idxFavorited], bookmarked: true }
        }
        return worksNew
      })
    }
    bookmarksInitializedFromLocalStorage = false
  }

  function handleFavoriteButton(e, workClicked) {
    console.log('at', favorites)
    let lestReadFavorites = []
    if (favorites.length > 3) {
      console.log('>3', favorites)
    }
    setFavorites(favWorks => {
      // if (favWorks.length > 3) {
      //   console.log('>3', favorites)
      //   const msg = 'Your rank List already have three works. Please, delete at least one entry before trying to add another.'
      //   openSnackbar({ message: msg, variant: 'info' })
      //   // return [...favWorks]
      // }
      const idxMatch = favWorks.findIndex(item => item.ID === workClicked.ID)
      if (idxMatch > -1) { // Remove Work from Favorite
        favWorks.splice(idxMatch, 1)
        return favWorks
      }
      // console.log('favs', favWorks)
      if (favWorks.length > 2) {
        return favWorks
      }
      //   console.log('>3', favWorks)
      //   const msg = 'Your rank List already have three works. Please, delete at least one entry before trying to add another.'
      //   openSnackbar({ message: msg, variant: 'info' })
      //   return [...favWorks]
      // }
      // Add work to favorite
      return [...favWorks, { ...workClicked, favorited: true }]
    })
    setWorks((works) => {
      let worksNew = works.map(item => item)
      lestReadFavorites = works.filter(work => work.favorited === true)
      console.log('favs filter, ', lestReadFavorites)
      const idxClickedWork = worksNew.map(item => item.ID).indexOf(workClicked.ID)
      if (!workClicked.favorited) {
        if (lestReadFavorites.length > 2) { //Operation Remove from Favorites
          console.log('cannot add', lestReadFavorites)
          const msg = 'Your rank List already have three works. Please, delete at least one entry before trying to add another.'
          setTriggerNotifier({show: true, message: msg, variant: 'info'})
          return worksNew
        }
      }
      // console.log('fav-handle', workClicked)
      worksNew[idxClickedWork] = { ...workClicked, favorited: !workClicked.favorited }
      const msg = !workClicked.favorited ? 'Poster added to Evaluation List' : 'Poster removed from Evaluation List'
      setTriggerNotifier({show: true, message: msg, variant: 'info'})
      return worksNew
    })
    // const favs = works.filter(work => work.favorited === true)
    // console.log('favorites from work', favs)
    // if (favs.length > 2 && !workClicked.favorited) { //Operation Remove from Favorites
    //   console.log('favorites from work length > 2', favs)
    //   const msg = 'Your rank List already have three works. Please, delete at least one entry before trying to add another.'
    //   openSnackbar({ message: msg, variant: 'info' })
    // } else {
    // const msg = !workClicked.favorited ? 'Adicionado ao link de Favoritos' : 'Removido dos favoritos.'
    // openSnackbar({ message: msg, variant: 'info' })
    // }
  }

  function handleBookmarksButton(e, workClicked) {
    setBookmarks(favWorks => {
      const idxMatch = favWorks.findIndex(item => item.ID === workClicked.ID)
      if (idxMatch > -1) { // Remove Work from Favorite
        favWorks.splice(idxMatch, 1)
        return favWorks
      }
      return [...favWorks, { ...workClicked, bookmarked: true }]
    })
    setWorks((works) => {
      let worksNew = works.map(item => item)
      const idxClickedWork = worksNew.map(item => item.ID).indexOf(workClicked.ID)
      worksNew[idxClickedWork] = { ...workClicked, bookmarked: !workClicked.bookmarked }
      const msg = !workClicked.bookmarked ? 'Contribution added to Bookmarks' : 'Contribution removed from Bookmarks'
      setTriggerNotifier({show: true, message: msg, variant: 'info'})
      return worksNew
    })
  }

  useEffect(
    () => {
      dsv(';', csvFileName, (loadedData) => {
        Object.keys(loadedData).map(function (key, val) {
          loadedData[key] = loadedData[key].trim();
          return 0
        });
        loadedData.favorited = false
        loadedData.bookmarked = false
        return loadedData
      }).then((data) => {
        // console.log('data here', data)
        setWorks(data)
      }).catch(err => console.log(err)) //To Notify!
    },
    [],
  );

  const handleShowNotificationPosterEvaluation = ({message}) => {
    setTriggerNotifier({show: true, message: message})
  }

  return (
    <Router basename={process.env.PUBLIC_URL}>
      <div className={classes.root}>
        <CssBaseline />
        <AppBar {..._useToggle} />
        <Drawer{..._useToggle} />

        <main className={classes.content}>
          <div className={classes.toolbar} />
          <Suspense fallback={<Loading />}>
            <Switch>
              <Route key="Poster Evaluation" exact path="/poster-evaluation"
                render={(props) => (<Favoritos {...props}
                  favorites={favorites}
                  handleFavoriteButton={handleFavoriteButton}
                  handleShowNotification={handleShowNotificationPosterEvaluation}
                  handleBookmarksButton={handleBookmarksButton}
                   />)} />
              <Route key="Bookmarks" exact path="/bookmarks"
                render={(props) => (<BookMarksPage {...props}
                  bookmarks={bookmarks}
                  handleBookmarksButton={handleBookmarksButton}
                  handleShowNotification={handleShowNotificationPosterEvaluation}
                   />)} />
              <Route key="papers" exact path="/papers"
                render={(props) => (<Trabalhos {...props}
                  works={works} setWorks={setWorks}
                  handleFavoriteButton={handleFavoriteButton}
                  handleBookmarksButton={handleBookmarksButton} />)} />
              {routes.map((route, key) => <Route key={key} exact {...route} />)}
            </Switch>
          </Suspense>
          <PureNotifier
            msg={triggerNotifier.message}
            open={triggerNotifier.show}
            handleClose={() => setTriggerNotifier({show: false, message: '', variant: ''})}
            >
          </PureNotifier>
        </main>
        {/* { triggerNotifier.show === true ?
          () => {
            openSnackbar({message: triggerNotifier.message, variant: triggerNotifier.variant})
            setTriggerNotifier({show: false, message: '', variant: ''})
          }
          : null
        } */}
        {/* <Notifier></Notifier> */}

      </div>
    </Router>
  )
}

export default App
    {/* <PureNotifier */}
      // open={triggerNotifier.show}
      // msg={triggerNotifier.message}
      // variant={triggerNotifier.variant}

    // >
